// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".corner-ribbon{font-size:10px;left:auto;position:absolute;text-align:center;transform:rotate(45deg)}.two-words{right:-20px;top:20px;width:95px}.one-word{right:-25px;top:11px;width:90px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
